module.exports = __webpack_public_path__ + "img/107.ce024e5d.jpg";